// extracted by mini-css-extract-plugin
module.exports = {"container":"Airdrop_container__1Wqy1","box":"Airdrop_box__2vemM"};